// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"aa0a63e4","255":"930d8e3e","457":"f33613cf","527":"2639d210","709":"0c40d7c3","719":"844d4468","788":"32d5c941","804":"7afd3c6c","819":"ea1b1369","844":"e8b0cf97","871":"71ff3197","922":"babbf056"}[chunkId] + ".chunk.js";
};